// src/actions/mqttActions.js
import mqttService from "../MqttService";

export const MQTT_CONNECT = "MQTT_CONNECT";
export const MQTT_MESSAGE_RECEIVED = "MQTT_MESSAGE_RECEIVED";
export const MQTT_SUBSCRIBE = "MQTT_SUBSCRIBE";
export const MQTT_UNSUBSCRIBE = "MQTT_UNSUBSCRIBE";

export const connectMQTT = () => (dispatch) => {
  mqttService.connect((topic, message) => {
    dispatch({
      type: MQTT_MESSAGE_RECEIVED,
      payload: { topic, message },
    });
  });

  dispatch({ type: MQTT_CONNECT });
};

export const subscribeMQTT = (topic, handler) => (dispatch) => {
  //console.log(topic, handler
  // );
  mqttService.subscribe(topic, handler);
  dispatch({
    type: MQTT_SUBSCRIBE,
    payload: topic,
  });
};

export const unsubscribeMQTT = (topic) => (dispatch) => {
  mqttService.unsubscribe(topic);
  dispatch({
    type: MQTT_UNSUBSCRIBE,
    payload: topic,
  });
};

export const publishMQTT = (topic, message) => () => {
  mqttService.publish(topic, message);
};

export const disconnectMQTT = () => () => {
  mqttService.disconnect();
};
